import { inject, Injectable } from '@angular/core';

import {
  InventoryManagementSearchResult,
  InventoryManagementState,
  UpdateVehicleSelectAll,
  VehicleToggleState
} from 'remarketing-angular-library';
import { SaService } from 'smartauction-frontend-micro-library';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class VehicleToggleService extends SaService {

  private readonly store: Store;

  constructor() {
    super();
    this.store = inject(Store);
  }

  /*
    WARNING: This method is used inside an effect hook.
    Reading a signal inside this method could cause an infinite search call loop!!!
    If you must, ensure that the signal NEVER updates while the Sell Search Page is open
  */
  evaluateSelectAllCheckbox(): void {
    const searchResponse = this.store.selectSnapshot(InventoryManagementState.searchResponse)?.data;
    const selectedVehicles = this.store.selectSnapshot(VehicleToggleState.selectedVehicles);

    // in the case the search response returns no vehicles
    if (!searchResponse?.length || !selectedVehicles) {
      return;
    }

    const vehicleUuids = searchResponse.map(vehicle => vehicle.vehicleUuid);
    const selectedVehicleUuids = selectedVehicles.map((vehicle: InventoryManagementSearchResult) => vehicle.vehicleUuid);
    if (vehicleUuids.every(vehicleUuid => selectedVehicleUuids.includes(vehicleUuid))) {
      this.store.dispatch(new UpdateVehicleSelectAll(true));
    } else {
      this.store.dispatch(new UpdateVehicleSelectAll(false));
    }
  }
}
